import React, { Component } from "react";
import Photosevent from "../PhotosEvent/PhotosEvent";
import UploadPhoto from "../UploadPhoto/UploadPhoto";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";

class Photos extends Component {
	state = {};

	constructor(props) {
		super(props);
		this.state = {
			uploadPhotos:[]

		};
	}

	componentDidMount() {
	}

	componentDidUpdate(prevProps, prevState) {}
	handleChange = name => event => {
//		this.setState({ ...this.state, [name]: event.target.checked });
	};

	handleCreate = () => {
		this.setState({
			showModal: true,
			id: "",
			canDelete: false,
			eventname:"",
			uploadPhotos:[{photo:"a"}]
		});
	};

	handleClose = () => {
		this.setState({
			showModal: false
		});
	};

	handleSave = () => {
		
	}

	photoUploaded = (location) => 
	{
		console.log(location);
	}

	thumbnailUploaded = (location) => 
	{
		console.log(location);
	}


	render() {
		return (
			<React.Fragment>
					<Modal open={this.state.showModal}>
					<Paper
						style={{
							display: "grid",
							width: "50%",
							padding: "20px",
							margin: "10% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							<form>
								<h2>Crear Evento</h2>

								<TextField
									id="standard-basic"
									label="Nombre"
									multiline
									rowsMax="4"
									style={{ marginBottom: "20px", width: "100%" }}
									value={this.state.eventname}
									onChange={e => this.setState({ eventname: e.target.value })}
								/>
								<br />
								{
									this.state.uploadPhotos.map( p => (
										<UploadPhoto photo={p} upload={this.upload} changeInputValue={this.photoUploaded} changeThumbnailValue={this.thumbnailUploaded}/>
									))
								}
							
							</form>

							<Button
								onClick={this.handleSave}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Guardar
							</Button>
							<Button onClick={this.handleClose} color="primary">
								Cerrar
							</Button>
						</div>
					</Paper>
				</Modal>
				<h2 style={{ width: "100%", textAlign: "left" }}>Galería de Fotos</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreate}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Crear Evento
					</Button>
				</div>
                <div>
                {this.props.photos.map(p => (
                    <div><Photosevent id={p.idgalleryevent} name={p.eventname} photos={p.photos}/> &nbsp;</div>
                ))}

                </div>

			</React.Fragment>
		);
	}
}

export default Photos;
